import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AppLanguage } from '../lib/i18n';
import { useTeamNameDisplayStore } from './useTeamNameDisplayStore';

interface LanguageState {
  language: AppLanguage;
  setLanguage: (lang: AppLanguage) => void;
  toggleLanguage: () => void;
}

const getInitialLanguage = (): AppLanguage => {
  try {
    const raw = localStorage.getItem('app-language-preference');
    if (raw) {
      const lang = JSON.parse(raw)?.state?.language;
      if (lang === 'fr' || lang === 'ar') return lang;
    }
  } catch {}
  return 'fr';
};

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: getInitialLanguage(),
      setLanguage: (lang) => {
        set({ language: lang });
        // Auto-sync: Arabic UI → Arabic team names, French UI → French team names
        useTeamNameDisplayStore
          .getState()
          .setDisplayMode(lang === 'ar' ? 'arabic' : 'french');
      },
      toggleLanguage: () =>
        set((state) => {
          const next: AppLanguage = state.language === 'fr' ? 'ar' : 'fr';
          useTeamNameDisplayStore
            .getState()
            .setDisplayMode(next === 'ar' ? 'arabic' : 'french');
          return { language: next };
        }),
    }),
    { name: 'app-language-preference' }
  )
);
